import React from "react";

import { Card, CardBody, Row, Col, Button, Alert } from "reactstrap";
import {
  Textbox,
  Checkbox,
  Textarea,
  Select as Select1,
} from "react-inputs-validation";
import "../../styles/estilos.css";
import Page from "components/Page";
//import ValoresCotizacion from "./ValoresCotizacion";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import DatePicker, { registerLocale } from "react-datepicker";
import {
  fetchConsultarIdentificacionAP,
  guardarFacturacionFetch,
} from "../../redux/actions/aCotizacion";
import { runInNewContext } from "vm";
import { ambienteAplicacion } from "../../constants/urls";
import Select from "react-select";
import makeAnimated from "react-select/lib/animated";
import logo from "assets/img/logo/logo_aig_login-2.png";
import LoadingScreen from "react-loading-screen";
import ValoresCotizacion from "./valoresFacturacion";
import { type } from "os";
import { ErrorMsgConstants, expresionesRegulares, infoIds } from "../../constants";
import { estaEnListaNegra, LimpiarListaNegra } from "../../redux/actions/ACarritoProductos";


class datosFacturacion extends React.Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(this.props.location.search);

    this.state = {
      validate: false,
      valAlerta: false,
      idCarrito: queryParams.get("id"),
      pathRegresar: undefined,
      mismosDatos: true,
      datosPagador: {
        id: this.props.dataFacturacion.carDatosContratante
          ? this.props.dataFacturacion.carDatosContratante.mongoIdentificador
          : "",
        identificacion: this.props.dataFacturacion.carDatosContratante
          ? this.props.dataFacturacion.carDatosContratante.cliIdentificacion
          : "",
        codTipodocumento: this.props.dataFacturacion.carDatosContratante
          ? this.props.dataFacturacion.carDatosContratante.cliTipoDocumento
          : "",
        cliNombres: this.props.dataFacturacion.carDatosContratante
          ? this.props.dataFacturacion.carDatosContratante.cliNombres
          : "",
        cliApellidos: this.props.dataFacturacion.carDatosContratante
          ? this.props.dataFacturacion.carDatosContratante.cliApellidos
          : "",
        correo: this.props.dataFacturacion.carDatosContratante
          ? this.props.dataFacturacion.carDatosContratante.cliEmail
          : "",
        direccion: this.props.dataFacturacion.carDatosContratante
          ? this.props.dataFacturacion.carDatosContratante.cliDireccion
          : "",
        celular: this.props.dataFacturacion.carDatosContratante
          ? this.props.dataFacturacion.carDatosContratante.cliCelular
          : "",
        codEstadoCivil: this.props.dataFacturacion.carDatosContratante
          ? this.props.dataFacturacion.carDatosContratante.cliCodEstadoCivil
          : "",
        codGenero: this.props.dataFacturacion.carDatosContratante
          ? this.props.dataFacturacion.carDatosContratante.cliCodGenero
          : "",
        provincia: this.props.dataFacturacion.carDatosContratante
          ? this.props.dataFacturacion.carDatosContratante.provincia
          : "",
        ciudad: this.props.dataFacturacion.carDatosContratante
          ? this.props.dataFacturacion.carDatosContratante.ciudad
          : "",
        fechaNacimiento: this.props.dataFacturacion.carDatosContratante
          ? this.cambiarStringaFecha(
            this.props.dataFacturacion.carDatosContratante.cliFechaNacimiento
          )
          : null,
        fechaEmisionPasaporte: this.props.dataFacturacion.carDatosContratante
          ? this.cambiarStringaFecha(
            this.props.dataFacturacion.carDatosContratante
              .cliFechaExpedicionPasaporte
          )
          : null,
        fechaCaducidadPasaporte: this.props.dataFacturacion.carDatosContratante
          ? this.cambiarStringaFecha(
            this.props.dataFacturacion.carDatosContratante
              .cliFechaVecimientoPasaporte
          )
          : null,
        fechaIngresoPais: this.props.dataFacturacion.carDatosContratante
          ? this.cambiarStringaFecha(
            this.props.dataFacturacion.carDatosContratante.cliFechaIngresoPais
          )
          : null,
      },
      valDatosPagador: {
        hasIdentificacionError: true,
        hasCodTipoDocError: true,
        hasNombreError: true,
        hasApellidoError: true,
        hasECivilError: true,
        hasGeneroError: true,
        hasCorreoError: true,
        hasDireccionError: true,
        hasCelularError: true,
        hasFechaNacimiento: false,
        hasFechaEmisionPasaporte: false,
        hasFechaCaducidadPasaporte: false,
        hasFechaIngresoPais: false,
        hasProvinciaError: false,
        hasCiudadError: false,
        esPasaporte:
          this.props.dataFacturacion.carDatosContratante &&
            this.props.dataFacturacion.carDatosContratante.cliTipoDocumento ===
            infoIds.codigoPasaporteStr
            ? true
            : false,
        esruc:
          this.props.dataFacturacion.carDatosContratante &&
            this.props.dataFacturacion.carDatosContratante.cliTipoDocumento ===
            infoIds.codigoRucStr
            ? true
            : false,
      },
      datosFacturacion: {
        id: "",
        identificacion: "",
        codTipodocumento: "",
        cliNombres: "",
        cliApellidos: "",
        correo: "",
        direccion: "",
        celular: "",
        codEstadoCivil: "",
        codGenero: "",
        provincia: "",
        ciudad: "",
        fechaNacimiento: null,
        fechaEmisionPasaporte: null,
        fechaCaducidadPasaporte: null,
        fechaIngresoPais: null,
      },
      valDatosFacturacion: {
        hasIdentificacionError: true,
        hasCodTipoDocError: true,
        hasNombreError: true,
        hasApellidoError: true,
        hasECivilError: true,
        hasGeneroError: true,
        hasCorreoError: true,
        hasDireccionError: true,
        hasCelularError: true,
        hasFechaNacimiento: false,
        hasFechaEmisionPasaporte: false,
        hasFechaCaducidadPasaporte: false,
        hasFechaIngresoPais: false,
        hasProvinciaError: false,
        hasCiudadError: false,
        esPasaporte: false,
        esruc: false,
      },
      personeriValue: '1',
      personeriValueF: '1',
    };
    this.validateForm = this.validateForm.bind(this);
    this.onClickRegresar = this.onClickRegresar.bind(this);
    this.reiniciarScroll = this.reiniciarScroll.bind(this);
  }

  async onClickRegresar(e) {
    e.preventDefault();
    //Validar si se debe enviar un arametro extra

    let paramAdicional = "";
    if (
      this.props.dataFacturacion &&
      this.props.dataFacturacion.paramAdicional
    ) {
      paramAdicional = this.props.dataFacturacion.paramAdicional;
    }
    const { pathRegresar, idCarrito } = this.state;
    this.props.history.push({
      pathname: pathRegresar,
      search: `?id=${idCarrito}${paramAdicional}&resumen=true`,
    });
  }

  getTipoDocumentos() {
    const listadoTipoDocumentos = [
      { id: "", name: "Seleccione el tipo de documento" },
      { id: infoIds.codigoCedulaNum, name: "Cédula" },
      { id: infoIds.codigoRucNum, name: "Ruc" },
      { id: infoIds.codigoPasaporteNum, name: "Pasaporte" },
    ];
    return listadoTipoDocumentos;
  }
  toggleValidating = (validate) => {
    this.setState({ validate });
  };
  validateForm = async () => {
    this.toggleValidating(true);
    const {
      idCarrito,
      datosPagador,
      datosFacturacion,
      mismosDatos,
      valDatosPagador,
      valDatosFacturacion,
    } = this.state;

    let contValPag = 0;
    let contValFac = 0;
    let datosJSON = {};
    let datosAuxP = {};
    let datosAuxF = {};

  

    datosPagador.cliApellidos = datosPagador.cliApellidos? datosPagador.codTipodocumento=='2'? '':datosPagador.cliApellidos.trim() : ''
    datosPagador.direccion = datosPagador.direccion?datosPagador.direccion.trim():''
    datosPagador.cliNombres = datosPagador.cliNombres?datosPagador.cliNombres.trim():''

    datosFacturacion.cliApellidos = datosFacturacion.cliApellidos? datosFacturacion.codTipodocumento =='2' ? '' : datosFacturacion.cliApellidos.trim():''
    datosFacturacion.direccion = datosFacturacion.direccion?datosFacturacion.direccion.trim():''
    datosFacturacion.cliNombres = datosFacturacion.cliNombres?datosFacturacion.cliNombres.trim():''

 

    let contratante = {
      esruc: valDatosPagador.esruc,
      esPasaporte: valDatosPagador.esPasaporte,
      provincia: datosPagador.provincia,
      ciudad: datosPagador.ciudad,
      fechaNacimiento: datosPagador.fechaNacimiento,
      fechaEmisionPasaporte: datosPagador.fechaEmisionPasaporte,
      fechaCaducidadPasaporte: datosPagador.fechaCaducidadPasaporte,
      fechaIngresoPais: datosPagador.fechaIngresoPais,
    };
    let facturacion = {
      esruc: valDatosFacturacion.esruc,
      esPasaporte: valDatosFacturacion.esPasaporte,
      provincia: datosFacturacion.provincia,
      ciudad: datosFacturacion.ciudad,
      fechaNacimiento: datosFacturacion.fechaNacimiento,
      fechaEmisionPasaporte: datosFacturacion.fechaEmisionPasaporte,
      fechaCaducidadPasaporte: datosFacturacion.fechaCaducidadPasaporte,
      fechaIngresoPais: datosFacturacion.fechaIngresoPais,
    };

   

    if (contratante.provincia === "")
      this.setState((prevState) => ({
        valDatosPagador: {
          ...prevState.valDatosPagador,
          hasProvinciaError: true,
        },
      }));
    if (contratante.ciudad === "")
      this.setState((prevState) => ({
        valDatosPagador: { ...prevState.valDatosPagador, hasCiudadError: true },
      }));
    if (contratante.fechaNacimiento === null)
      this.setState((prevState) => ({
        valDatosPagador: {
          ...prevState.valDatosPagador,
          hasFechaNacimiento: true,
        },
      }));
    if (contratante.esPasaporte) {
      if (contratante.fechaEmisionPasaporte === null)
        this.setState((prevState) => ({
          valDatosPagador: {
            ...prevState.valDatosPagador,
            hasFechaEmisionPasaporte: true,
          },
        }));
      if (contratante.fechaCaducidadPasaporte === null)
        this.setState((prevState) => ({
          valDatosPagador: {
            ...prevState.valDatosPagador,
            hasFechaCaducidadPasaporte: true,
          },
        }));
      if (contratante.fechaIngresoPais === null)
        this.setState((prevState) => ({
          valDatosPagador: {
            ...prevState.valDatosPagador,
            hasFechaIngresoPais: true,
          },
        }));
    }



    for (const prop in valDatosPagador) {
      if (prop !== "esruc" && prop !== "esPasaporte") {
        if (contratante.esruc) {
          if (
            prop !== "hasApellidoError" &&
            prop !== "hasECivilError" &&
            prop !== "hasGeneroError" &&
            prop !== "hasFechaEmisionPasaporte" &&
            prop !== "hasFechaCaducidadPasaporte" &&
            prop !== "hasFechaIngresoPais"
          ) {
            if (valDatosPagador[prop] === true) contValPag++;
          }
        } else if (contratante.esPasaporte) {
          if (valDatosPagador[prop] === true) contValPag++;
        } else {
          if (
            prop !== "hasFechaEmisionPasaporte" &&
            prop !== "hasFechaCaducidadPasaporte" &&
            prop !== "hasFechaIngresoPais"
          ) {
            if (valDatosPagador[prop] === true) contValPag++;
          }
        }
      }
    }
    if (contValPag === 0) {

      
      datosAuxP = { ...this.state.datosPagador };
    
      datosAuxP = this.modificarStateFechas(datosAuxP);
      if (mismosDatos) {
        datosJSON = {
          empresa: "AIGMETROPOLITANA",
          plataforma: "WEB",
          datosContratante: datosAuxP,
          datosPagadorFacturacion: datosAuxP,
          idCarrito: idCarrito,
          ambiente: ambienteAplicacion,
        };
      } else {
        if (facturacion.provincia === "")
          this.setState((prevState) => ({
            valDatosFacturacion: {
              ...prevState.valDatosFacturacion,
              hasProvinciaError: true,
            },
          }));
        if (facturacion.ciudad === "")
          this.setState((prevState) => ({
            valDatosFacturacion: {
              ...prevState.valDatosFacturacion,
              hasCiudadError: true,
            },
          }));
        if (facturacion.fechaNacimiento === null)
          this.setState((prevState) => ({
            valDatosFacturacion: {
              ...prevState.valDatosFacturacion,
              hasFechaNacimiento: true,
            },
          }));
        if (facturacion.esPasaporte) {
          if (facturacion.fechaEmisionPasaporte === null)
            this.setState((prevState) => ({
              valDatosFacturacion: {
                ...prevState.valDatosFacturacion,
                hasFechaEmisionPasaporte: true,
              },
            }));
          if (facturacion.fechaCaducidadPasaporte === null)
            this.setState((prevState) => ({
              valDatosFacturacion: {
                ...prevState.valDatosFacturacion,
                hasFechaCaducidadPasaporte: true,
              },
            }));
          if (facturacion.fechaIngresoPais === null)
            this.setState((prevState) => ({
              valDatosFacturacion: {
                ...prevState.valDatosFacturacion,
                hasFechaIngresoPais: true,
              },
            }));
        }

        for (const prop in valDatosFacturacion) {
          if (prop !== "esruc" && prop !== "esPasaporte") {
            if (facturacion.esruc) {
              if (
                prop !== "hasApellidoError" &&
                prop !== "hasECivilError" &&
                prop !== "hasGeneroError" &&
                prop !== "hasFechaEmisionPasaporte" &&
                prop !== "hasFechaCaducidadPasaporte" &&
                prop !== "hasFechaIngresoPais"
              ) {
                if (valDatosFacturacion[prop] === true) contValFac++;
              }
            } else if (facturacion.esPasaporte) {
              if (valDatosFacturacion[prop] === true) contValFac++;
            } else {
              if (
                prop !== "hasFechaEmisionPasaporte" &&
                prop !== "hasFechaCaducidadPasaporte" &&
                prop !== "hasFechaIngresoPais"
              ) {
                if (valDatosFacturacion[prop] === true) contValFac++;
              }
            }
          }
        }

        if (contValFac === 0) {
          datosAuxF = { ...this.state.datosFacturacion };
          datosAuxF = this.modificarStateFechas(datosFacturacion);
          datosJSON = {
            empresa: "AIGMETROPOLITANA",
            plataforma: "WEB",
            datosContratante: datosAuxP,
            datosPagadorFacturacion: datosAuxF,
            idCarrito: idCarrito,
            ambiente: ambienteAplicacion,
          };
        } else {
          //console.log("No valido F")
        }
      }
      if (contValFac === 0) {
        if(datosPagador.identificacion){
          await this.props.checkInListaNegra(datosPagador.identificacion)
        }
    
        if (this.props.datosListaNegra.inListaNegra === false) {

          if(datosFacturacion.identificacion){
            await this.props.checkInListaNegra(datosFacturacion.identificacion)
          }


          if (this.props.datosListaNegra.inListaNegra === false) {
            await this.props.guardarFacturacion(datosJSON);

            if (
              this.props.respuestaFacturacion.respuestaFacturacion &&
              this.props.respuestaFacturacion.respuestaFacturacion.transaccion ===
              true
            ) {
              this.props.history.push({
                pathname: "/forma-pago",
                search: `?id=${idCarrito}`,
              });
            } else {
              alert(
                "Ha ocurrido un error al procesar su petición. Por favor intente nuevamente."
              );
              // this.props.history.push({
              //   pathname: "/forma-pago",
              //   search: `?id=${idCarrito}`
              // });
              // this.setState({valAlerta:true})
              // this.reiniciarScroll();
              // console.log("Error al guardar datos")
            }
          }


        }




      }
    } else {
      //console.log("No valido")
    }

  };

  modificarStateFechas = (dataAux) => {
    dataAux.fechaNacimiento = `${dataAux.fechaNacimiento !== null
      ? this.cambiarFechaaString(dataAux.fechaNacimiento)
      : null
      }`;
    dataAux.fechaEmisionPasaporte = `${dataAux.fechaEmisionPasaporte !== null
      ? this.cambiarFechaaString(dataAux.fechaEmisionPasaporte)
      : null
      }`;
    dataAux.fechaIngresoPais = `${dataAux.fechaIngresoPais !== null
      ? this.cambiarFechaaString(dataAux.fechaIngresoPais)
      : null
      }`;
    dataAux.fechaCaducidadPasaporte = `${dataAux.fechaCaducidadPasaporte !== null
      ? this.cambiarFechaaString(dataAux.fechaCaducidadPasaporte)
      : null
      }`;

    if (dataAux.codTipodocumento != '3') {
      delete dataAux['fechaCaducidadPasaporte']
      delete dataAux['fechaEmisionPasaporte']
      delete dataAux['fechaIngresoPais']
    }

    return dataAux;
  };

  cambiarStringaFecha = (valor) => {
    if (typeof valor === "string") {
      let fecha = valor.slice(0, 10).split("/", 3);
      if (fecha.length === 3)
        return new Date(fecha[2], parseInt(fecha[1]) - 1, fecha[0]);
      else return null;
    }
    return valor;
  };

  cambiarFechaaString = (valor) => {
    if (valor !== null && valor !== undefined) {
      let fecha = valor;
      fecha = fecha.toISOString().slice(0, 10).replace(/-/g, "/");
      const array = fecha.split("/");
      return `${array[2]}/${array[1]}/${array[0]}`;
    }
    return valor;
  };

  consultaRucCedula = async (params) => {
    const { identificacion, tipo, tipodato } = params;
    let datos = "";
    let prov = "";
    let ciu = "";
    let valSelect = true;
    let valFecha = true;

    await this.props.consultarIdentificacion({
      empresa: "AIGMETROPOLITANA",
      identificador: identificacion,
      tipo: tipo,
    });

    if (Object.keys(this.props.datosIdentificacion.IdentificacionAP).length > 0)
      datos = this.props.datosIdentificacion.IdentificacionAP[0];

    const {
      mongoIdentificador = "",
      nombre = "",
      nombres = "",
      apellidos = "",
      direccion = "",
      paiCodigoCore = "",
      provCodigoCore = "",
      provNombre = "",
      ciuCodigoCore = "",
      ciuNombre = "",
      correo = "",
      celular = "",
      generoCod = "",
      cliCodigoEstadoCivil = "",
      fechNacimiento = null,
    } = datos;

    if (fechNacimiento !== null) valFecha = false;

    if (
      provCodigoCore !== "" &&
      provCodigoCore !== undefined &&
      provCodigoCore !== null
    ) {
      this.props.onChangeProvincia(provCodigoCore);

      prov = {
        value: `${provCodigoCore ? provCodigoCore : ""}`,
        label: `${provNombre ? provNombre : ""}`,
        paiCodigoCore: `${paiCodigoCore ? paiCodigoCore : ""}`,
      };

      ciu = {
        value: `${ciuCodigoCore ? ciuCodigoCore : ""}`,
        label: `${ciuNombre ? ciuNombre : ""}`,
      };
      valSelect = false;
    }

    //VALIDA SI CONSULTA EL CONTRATANTE O EL PAGADORFACTURACION
    if (tipodato === "1") {
      if (tipo === "ruc")
        this.setState((prevState) => ({
          datosPagador: {
            ...prevState.datosPagador,
            id: `${mongoIdentificador ? mongoIdentificador : ""}`,
            cliNombres: `${nombre ? nombre : ""}`,
            direccion: `${direccion ? direccion : ""}`,
            fechaNacimiento: fechNacimiento
              ? this.cambiarStringaFecha(fechNacimiento)
              : null,
            celular: `${celular ? celular : ""}`,
            correo: `${correo ? correo : ""}`,
            provincia: prov,
            ciudad: ciu,
          },
          valDatosPagador: {
            ...prevState.valDatosPagador,
            hasProvinciaError: valSelect,
            hasCiudadError: valSelect,
            hasFechaNacimiento: valFecha,
          },
          validate: false,
        }));
      else if (tipo === "cedula")
        this.setState((prevState) => ({
          datosPagador: {
            ...prevState.datosPagador,
            id: `${mongoIdentificador ? mongoIdentificador : ""}`,
            cliNombres: `${nombres ? nombres : ""}`,
            cliApellidos: `${apellidos ? apellidos : ""}`,
            direccion: `${direccion ? direccion : ""}`,
            correo: `${correo ? correo : ""}`,
            celular: `${celular ? celular : ""}`,
            codGenero: `${generoCod ? generoCod : ""}`,
            codEstadoCivil: `${cliCodigoEstadoCivil ? cliCodigoEstadoCivil : ""
              }`,
            fechaNacimiento: fechNacimiento
              ? this.cambiarStringaFecha(fechNacimiento)
              : null,
            provincia: prov,
            ciudad: ciu,
          },
          valDatosPagador: {
            ...prevState.valDatosPagador,
            hasProvinciaError: valSelect,
            hasCiudadError: valSelect,
            hasFechaNacimiento: valFecha,
          },
          validate: false,
        }));
    }
    if (tipodato === "2") {
      if (tipo === "ruc")
        this.setState((prevState) => ({
          datosFacturacion: {
            ...prevState.datosFacturacion,
            id: `${mongoIdentificador ? mongoIdentificador : ""}`,
            cliNombres: `${nombre ? nombre : ""}`,
            direccion: `${direccion ? direccion : ""}`,
            correo: `${correo ? correo : ""}`,
            celular: `${celular ? celular : ""}`,
            fechaNacimiento: fechNacimiento
              ? this.cambiarStringaFecha(fechNacimiento)
              : null,
            provincia: prov,
            ciudad: ciu,
          },
          valDatosFacturacion: {
            ...prevState.valDatosFacturacion,
            hasProvinciaError: valSelect,
            hasCiudadError: valSelect,
            hasFechaNacimiento: valFecha,
          },
          validate: false,
        }));
      else if (tipo === "cedula")
        this.setState((prevState) => ({
          datosFacturacion: {
            ...prevState.datosFacturacion,
            id: `${mongoIdentificador ? mongoIdentificador : ""}`,
            cliNombres: `${nombres ? nombres : ""}`,
            cliApellidos: `${apellidos ? apellidos : ""}`,
            direccion: `${direccion ? direccion : ""}`,
            correo: `${correo ? correo : ""}`,
            celular: `${celular ? celular : ""}`,
            codGenero: `${generoCod ? generoCod : ""}`,
            codEstadoCivil: `${cliCodigoEstadoCivil ? cliCodigoEstadoCivil : ""
              }`,
            fechaNacimiento: fechNacimiento
              ? this.cambiarStringaFecha(fechNacimiento)
              : null,
            provincia: prov,
            ciudad: ciu,
          },
          valDatosFacturacion: {
            ...prevState.valDatosFacturacion,
            hasProvinciaError: valSelect,
            hasCiudadError: valSelect,
            hasFechaNacimiento: valFecha,
          },
          validate: false,
        }));
    }

    setTimeout(() => this.setState({ validate: true }), 100);
  };

  textosCargando() {
    if (this.props.datosIdentificacion.consultarIdentificacionAPIsLoading)
      return "Cargando datos...";
    if (this.props.respuestaFacturacion.guardarDatosFacturacionIsLoading)
      return "Guardando datos de facturación...";
  }
  async componentDidMount() {
    this.props.limpiarDatosListaNegra()
    const { datosPagador } = this.state;
    this.reiniciarScroll();

    if (datosPagador.provincia !== "")
      this.props.onChangeProvincia(datosPagador.provincia.value);

    //Recuperar la url para la cotización
    console.log("dataFacturacion", this.props);
    if (
      this.props.dataFacturacion != null &&
      this.props.dataFacturacion.urlRegresar !== undefined
    ) {
      let cortarURl = this.props.dataFacturacion.urlRegresar.split("?");
      cortarURl = cortarURl[0];
      this.setState({ pathRegresar: "/" + cortarURl });
    }
    //VALIDA LOS DATOS AL INGRESAR
    this.validateForm();

    //completar informacion del carrito
    console.log('this.props.facturacion', this.props);

  }

  reiniciarScroll() {
    window.scroll(0, 0);
  }



  render() {
    let {
      validate,
      mismosDatos,
      datosFacturacion,
      datosPagador,
      valDatosFacturacion,
      valDatosPagador,
      valAlerta,
      personeriValue,
      mostrarPersoneriaF,
      personeriValueF
    } = this.state;
    const { catalogos, datosIdentificacion, respuestaFacturacion } = this.props;
    // if (datosPagador.fechaNacimiento) datosPagador.fechaNacimiento = this.cambiarStringaFecha(datosPagador.fechaNacimiento);
    // if (datosPagador.fechaCaducidadPasaporte) datosPagador.fechaCaducidadPasaporte = this.cambiarStringaFecha(datosPagador.fechaCaducidadPasaporte);
    // if (datosPagador.fechaEmisionPasaporte) datosPagador.fechaEmisionPasaporte = this.cambiarStringaFecha(datosPagador.fechaEmisionPasaporte);
    // if (datosPagador.fechaIngresoPais) datosPagador.fechaIngresoPais = this.cambiarStringaFecha(datosPagador.fechaIngresoPais);
    const listadoTipoDocumentos = [
      { id: 1, name: "Natural" },
      { id: 2, name: "Jurídica" },
    ];
    return (
      <LoadingScreen
        loading={
          datosIdentificacion.consultarIdentificacionAPIsLoading ||
          respuestaFacturacion.guardarDatosFacturacionIsLoading
          || this.props.datosListaNegra.listaNegraLoading
        }
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={this.textosCargando()}
      >
        <Page
          title="Datos Contrante - Facturación"
          breadcrumbs={[
            { name: "Datos Contrante - Facturación", active: true },
          ]}
        >
          <Row>
            <Col lg={8} md={12} sm={12} xs={12}>
              <div className="container-step">
                <div className="wrapper-step">
                  <div className="arrow-steps clearfix-step">
                    <div className="step"> {` 1. Cotización `} </div>
                    <div className="step"> {` 2. Resumen `} </div>
                    <div className="step current"> {` 3. Confirmación `} </div>
                    {/* {this.props.dataUsuario.usu_tipo_usuario === "cliente" && (
                      <div className="step"> {` 4. Forma de Pago `} </div>
                    )} */}
                    <div class="step"> {` 4. Forma de Pago `} </div>
                    <div class="step"> {` 5. Formulario de Vinculación `} </div>
                    <div class="step"> {` 6. Emisión `} </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              lg={8}
              md={12}
              sm={12}
              xs={12}
              className="detalle-cotizacion-box"
            >
              {valAlerta && (
                <Row>
                  <Col
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="div-align-center"
                  >
                    <Alert color="danger">
                      <p style={{ textAlign: "center" }}>
                        <i
                          className="fa fa-exclamation-triangle fa-3x"
                          aria-hidden="true"
                        ></i>
                      </p>
                      <p style={{ textAlign: "center" }}>
                        {
                          "No se pudo procesar su solicitud. Inténtalo nuevamente"
                        }
                      </p>
                    </Alert>
                  </Col>

                  
                </Row>
              )}
              <Card className="flex-row ">
                <CardBody>
                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <Button
                        className={"button-white"}
                        onClick={this.onClickRegresar}
                      >
                        <i
                          className="fa fa-chevron-circle-left"
                          aria-hidden="true"
                        />{" "}
                        REGRESAR A RESUMEN
                      </Button>
                    </Col>
                  </Row>
                  {/* <h3>{`Cotización #`}</h3> */}
                  <Row>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <h4 style={{ fontWeight: "bold" }}>
                        Datos del Contratante
                      </h4>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <div>(*) Campos Requeridos</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Tipo de identificación(*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Select1
                        tabIndex="6" // Optional.[String or Number].Default: none.
                        id={"selecTipoIdentificacion"} // Optional.[String].Default: "". Input ID.
                        name={"selecTipoIdentificacion"} // Optional.[String].Default: "". Input name.
                        value={datosPagador.codTipodocumento} // Optional.[String].Default: "".
                        validate={validate}
                        optionList={this.getTipoDocumentos()} // Required.[Array of Object(s)].Default: [].
                        onChange={(codTipodocumento, e) => {
                          this.setState((prevState) => ({
                            datosPagador: {
                              ...prevState.datosPagador,
                              codTipodocumento,
                            },
                          }));

                          if (codTipodocumento === infoIds.codigoPasaporteStr) {
                            this.setState((prevState) => ({
                              valDatosPagador: {
                                ...prevState.valDatosPagador,
                                esruc: false,
                                esPasaporte: true,
                              },
                            }));
                          } else if (codTipodocumento === infoIds.codigoRucStr) {
                            this.setState((prevState) => ({
                              valDatosPagador: {
                                ...prevState.valDatosPagador,
                                esruc: true,
                                esPasaporte: false,
                              },
                            }));
                          } else {
                            this.setState((prevState) => ({
                              valDatosPagador: {
                                ...prevState.valDatosPagador,
                                esruc: false,
                                esPasaporte: false,
                              },
                            }));
                          }
                          document.getElementById("identificacion").focus();
                          //document.getElementById("selecTipoIdentificacion").focus();
                        }} // Optional.[Func].Default: () => {}. Will return the value.
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                        validationCallback={(res) =>
                          this.setState((prevState) => ({
                            valDatosPagador: {
                              ...prevState.valDatosPagador,
                              hasCodTipoDocError: res,
                            },
                            validate: false,
                          }))
                        }
                        validationOption={{
                          name: "selecTipoIdentificacion", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError:
                            "Por favor seleccione el tipo de identificación",
                        }}
                      />
                    </Col>
                  </Row>
                  {datosPagador && datosPagador.codTipodocumento && datosPagador.codTipodocumento === infoIds.codigoRucStr &&
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Seleccione personería(*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <Select1
                          tabIndex="6" // Optional.[String or Number].Default: none.
                          id={"selectPersoneria"} // Optional.[String].Default: "". Input ID.
                          name={"selectPersoneria"} // Optional.[String].Default: "". Input name.
                          value={personeriValue} // Optional.[String].Default: "".
                          validate={validate}
                          optionList={listadoTipoDocumentos} // Required.[Array of Object(s)].Default: [].
                          onChange={(personeria, e) => {
                            if (personeriValue !== personeria) {
                              this.setState({
                                personeriValue: personeria,
                              });
                            }
                          }} // Optional.[Func].Default: () => {}. Will return the value.
                          onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                          validationCallback={(res) =>
                            this.setState({
                              validate: false,
                            })
                          }
                          validationOption={{
                            name: "selectPersoneria", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor seleccione la personería",
                          }}
                        />
                      </Col>
                    </Row>
                  }
                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Número de Identificación (*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Textbox
                        tabIndex="1"
                        type="text"
                        id="identificacion"
                        name="identificacion"
                        classNameInput={"form-control"}
                        value={datosPagador.identificacion}
                        validate={validate}
                        onChange={(identificacion, e) => {
                          this.setState((prevState) => ({
                            datosPagador: {
                              ...prevState.datosPagador,
                              identificacion,
                            },
                          }));
                          if (
                            valDatosPagador.esruc &&
                            identificacion.length === 13 &&
                            datosPagador.codTipodocumento === infoIds.codigoRucStr
                          ) {
                            this.consultaRucCedula({
                              identificacion: identificacion,
                              tipo: "ruc",
                              tipodato: "1",
                            });
                          } else if (
                            !valDatosPagador.esruc &&
                            identificacion.length === 10 &&
                            datosPagador.codTipodocumento === infoIds.codigoCedulaStr
                          ) {
                            this.consultaRucCedula({
                              identificacion: identificacion,
                              tipo: "cedula",
                              tipodato: "1",
                            });
                          }
                        }}
                        onBlur={(e) => { }}
                        validationCallback={(res) =>
                          this.setState((prevState) => ({
                            valDatosPagador: {
                              ...prevState.valDatosPagador,
                              hasIdentificacionError: res,
                            },
                            validate: false,
                          }))
                        }
                        validationOption={{
                          //name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          reg: valDatosPagador.esruc
                            ? /^\d{13}$/
                            : valDatosPagador.esPasaporte
                              ? ""
                              : /^\d{10}$/,
                          msgOnError:
                            "Por favor ingrese una identificación correcta",
                        }}
                      />
                    </Col>
                  </Row>
                  {valDatosPagador.esPasaporte === true && (
                    <div>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Fecha Expedición Pasaporte (*)</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          <DatePicker
                            {...this.props}
                            dateFormat="dd/MM/yyyy"
                            selected={datosPagador.fechaEmisionPasaporte}
                            onChange={(date) =>
                              this.setState((prevState) => ({
                                datosPagador: {
                                  ...prevState.datosPagador,
                                  fechaEmisionPasaporte: date,
                                },
                                valDatosPagador: {
                                  ...prevState.valDatosPagador,
                                  hasFechaEmisionPasaporte: date ? false : true,
                                },
                              }))
                            }
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText="Seleccione una fecha"
                            ref={(node) => {
                              this.ref = node;
                            }}
                          />
                          {valDatosPagador.hasFechaEmisionPasaporte && (
                            <span
                              style={{
                                display: "block",
                                color: "#ff5a57",
                                fontSize: "1rem",
                                marginLeft: "5px",
                              }}
                            >
                              Por favor ingrese una fecha
                            </span>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Fecha Vencimiento Pasaporte (*)</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          <DatePicker
                            {...this.props}
                            dateFormat="dd/MM/yyyy"
                            selected={datosPagador.fechaCaducidadPasaporte}
                            onChange={(date) =>
                              this.setState((prevState) => ({
                                datosPagador: {
                                  ...prevState.datosPagador,
                                  fechaCaducidadPasaporte: date,
                                },
                                valDatosPagador: {
                                  ...prevState.valDatosPagador,
                                  hasFechaCaducidadPasaporte: date
                                    ? false
                                    : true,
                                },
                              }))
                            }
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText="Seleccione una fecha"
                            ref={(node) => {
                              this.ref = node;
                            }}
                          />
                          {valDatosPagador.hasFechaCaducidadPasaporte && (
                            <span
                              style={{
                                display: "block",
                                color: "#ff5a57",
                                fontSize: "1rem",
                                marginLeft: "5px",
                              }}
                            >
                              Por favor ingrese una fecha
                            </span>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Fecha Ingreso al País (*)</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          <DatePicker
                            {...this.props}
                            dateFormat="dd/MM/yyyy"
                            selected={datosPagador.fechaIngresoPais}
                            onChange={(date) =>
                              this.setState((prevState) => ({
                                datosPagador: {
                                  ...prevState.datosPagador,
                                  fechaIngresoPais: date,
                                },
                                valDatosPagador: {
                                  ...prevState.valDatosPagador,
                                  hasFechaIngresoPais: date ? false : true,
                                },
                              }))
                            }
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText="Seleccione una fecha"
                            ref={(node) => {
                              this.ref = node;
                            }}
                          />
                          {valDatosPagador.hasFechaIngresoPais && (
                            <span
                              style={{
                                display: "block",
                                color: "#ff5a57",
                                fontSize: "1rem",
                                marginLeft: "5px",
                              }}
                            >
                              Por favor ingrese una fecha
                            </span>
                          )}
                        </Col>
                      </Row>
                    </div>
                  )}
                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>
                        {!valDatosPagador.esruc
                          ? "Nombres (*)"
                          : "Razón Social (*)"}
                      </h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Textbox
                        tabIndex="1"
                        type="text"
                        id="cliNombres"
                        name="cliNombres"
                        validate={validate}
                        classNameInput={"form-control"}
                        value={datosPagador.cliNombres}
                        onChange={(cliNombres, e) =>
                          this.setState((prevState) => ({
                            datosPagador: {
                              ...prevState.datosPagador,
                              cliNombres: cliNombres.toUpperCase().trimStart(),
                            },
                          }))
                        }
                        onBlur={(e) => { }}
                        validationCallback={(res) =>
                          this.setState((prevState) => ({
                            valDatosPagador: {
                              ...prevState.valDatosPagador,
                              hasNombreError: res,
                            },
                            validate: false,
                          }))
                        }
                        validationOption={{
                          name: "nombre", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          reg: valDatosPagador.esruc
                            ? ""
                            : /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/,
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError:
                            "Por favor ingrese los nombres, No deben tener caracteres especiales",
                        }}
                      />
                    </Col>
                  </Row>
                  {!valDatosPagador.esruc && (
                    <div>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Apellidos (*)</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          <Textbox
                            tabIndex="1"
                            type="text"
                            id="apellido"
                            name="apellido"
                            validate={validate}
                            classNameInput={"form-control"}
                            value={datosPagador.cliApellidos}
                            onChange={(cliApellidos, e) =>
                              this.setState((prevState) => ({
                                datosPagador: {
                                  ...prevState.datosPagador,
                                  cliApellidos: cliApellidos.toUpperCase().trimStart(),
                                },
                              }))
                            }
                            onBlur={(e) => {
                              //console.log(e);
                            }}
                            validationCallback={(res) =>
                              this.setState((prevState) => ({
                                valDatosPagador: {
                                  ...prevState.valDatosPagador,
                                  hasApellidoError: res,
                                },
                                validate: false,
                              }))
                            }
                            validationOption={{
                              //name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                              //check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                              reg: /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/,
                              msgOnError:
                                "Por favor ingrese los apellidos correctamente",
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Estado Civil(*)</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          <Select1
                            tabIndex="6" // Optional.[String or Number].Default: none.
                            id={"estadosCiviles"} // Optional.[String].Default: "". Input ID.
                            name={"estadosCiviles"} // Optional.[String].Default: "". Input name.
                            value={datosPagador.codEstadoCivil} // Optional.[String].Default: "".
                            optionList={catalogos.estadosCiviles} // Required.[Array of Object(s)].Default: [].
                            validate={validate}
                            onChange={(codEstadoCivil, e) =>
                              this.setState((prevState) => ({
                                datosPagador: {
                                  ...prevState.datosPagador,
                                  codEstadoCivil,
                                },
                              }))
                            }
                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                            validationCallback={(res) =>
                              this.setState((prevState) => ({
                                valDatosPagador: {
                                  ...prevState.valDatosPagador,
                                  hasECivilError: res,
                                },
                                validate: false,
                              }))
                            }
                            validationOption={{
                              name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                              msgOnError:
                                "Por favor seleccione su estado civil",
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Género(*)</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          <Select1
                            tabIndex="6" // Optional.[String or Number].Default: none.
                            id={"generos"} // Optional.[String].Default: "". Input ID.
                            name={"generos"} // Optional.[String].Default: "". Input name.
                            value={datosPagador.codGenero} // Optional.[String].Default: "".
                            optionList={catalogos.generos} // Required.[Array of Object(s)].Default: [].
                            validate={validate}
                            onChange={(codGenero, e) =>
                              this.setState((prevState) => ({
                                datosPagador: {
                                  ...prevState.datosPagador,
                                  codGenero,
                                },
                              }))
                            }
                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                            validationCallback={(res) =>
                              this.setState((prevState) => ({
                                valDatosPagador: {
                                  ...prevState.valDatosPagador,
                                  hasGeneroError: res,
                                },
                                validate: false,
                              }))
                            }
                            validationOption={{
                              name: "generos", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                              msgOnError: "Por favor seleccione el género",
                            }}
                          />
                        </Col>
                      </Row>
                    </div>
                  )}
                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Provincia(*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Select
                        value={datosPagador.provincia}
                        components={makeAnimated()}
                        onChange={(provincia, e) => {
                          this.setState((prevState) => ({
                            datosPagador: {
                              ...prevState.datosPagador,
                              provincia,
                              ciudad: "",
                            },
                            valDatosPagador: {
                              ...prevState.valDatosPagador,
                              hasProvinciaError: provincia ? false : true,
                            },
                          }));
                          this.props.onChangeProvincia(
                            provincia.value.toString()
                          );
                        }}
                        options={catalogos.provinciasSelect}
                        isSearchable={true}
                        placeholder={"Seleccione una provincia"}
                        isMulti={false}
                      />
                      {valDatosPagador.hasProvinciaError && (
                        <span
                          style={{
                            color: "#ff5a57",
                            fontSize: "1rem",
                            marginLeft: "5px",
                          }}
                        >
                          Por favor seleccione una provincia
                        </span>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Ciudad(*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Select
                        value={datosPagador.ciudad}
                        components={makeAnimated()}
                        onChange={(ciudad, e) => {
                          this.setState((prevState) => ({
                            datosPagador: { ...prevState.datosPagador, ciudad },
                            valDatosPagador: {
                              ...prevState.valDatosPagador,
                              hasCiudadError: ciudad ? false : true,
                            },
                          }));
                        }}
                        options={catalogos.ciudadesSelect}
                        isSearchable={true}
                        placeholder={"Seleccione una ciudad"}
                        isMulti={false}
                      />
                      {valDatosPagador.hasCiudadError && (
                        <span
                          style={{
                            color: "#ff5a57",
                            fontSize: "1rem",
                            marginLeft: "5px",
                          }}
                        >
                          Por favor seleccione una ciudad
                        </span>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>
                        {!valDatosPagador.esruc
                          ? "Fecha nacimiento(*)"
                          : "Fecha de Constitución (*)"}
                      </h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <DatePicker
                        {...this.props}
                        dateFormat="dd/MM/yyyy"
                        selected={datosPagador.fechaNacimiento}
                        onChange={(date) =>
                          this.setState((prevState) => ({
                            datosPagador: {
                              ...prevState.datosPagador,
                              fechaNacimiento: date,
                            },
                            valDatosPagador: {
                              ...prevState.valDatosPagador,
                              hasFechaNacimiento: date ? false : true,
                            },
                          }))
                        }
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control"
                        placeholderText="Seleccione una fecha"
                        ref={(node) => {
                          this.ref = node;
                        }}
                      />
                      {valDatosPagador.hasFechaNacimiento && (
                        <span
                          style={{
                            display: "block",
                            color: "#ff5a57",
                            fontSize: "1rem",
                            marginLeft: "5px",
                          }}
                        >
                          Por favor ingrese una fecha
                        </span>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Correo Electrónico (*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Textbox
                        type="text"
                        id="correo"
                        name="correo"
                        validate={validate}
                        classNameInput={"form-control"}
                        value={`${datosPagador.correo}`}
                        onChange={(correo, e) =>
                          this.setState((prevState) => ({
                            datosPagador: { ...prevState.datosPagador, correo },
                          }))
                        }
                        onBlur={(e) => {
                          //console.log(e);
                        }}
                        validationCallback={(res) =>
                          this.setState((prevState) => ({
                            valDatosPagador: {
                              ...prevState.valDatosPagador,
                              hasCorreoError: res,
                            },
                            validate: false,
                          }))
                        }
                        validationOption={{
                          name: "correo", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          reg:  expresionesRegulares.email,
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError:
                            "Por favor ingrese un correo electronico válido", // Optional.[Bool].Default: true. To determin if it is a required field.
                        }}
                      />
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Dirección (*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Textarea
                        // tabIndex="1"
                        type="input"
                        value={datosPagador.direccion}
                        name="direccion"
                        id="direccion"
                        classNameInput={"form-control"}
                        validate={validate}
                        onChange={(direccion, e) =>
                          this.setState((prevState) => ({
                            datosPagador: {
                              ...prevState.datosPagador,
                              direccion: direccion.toUpperCase().trimStart(),
                            },
                          }))
                        }
                        onBlur={(e) => {
                          //console.log(e);
                        }}
                        validationCallback={(res) =>
                          this.setState((prevState) => ({
                            valDatosPagador: {
                              ...prevState.valDatosPagador,
                              hasDireccionError: res,
                            },
                            validate: false,
                          }))
                        }
                        validationOption={{
                          name: "direccion", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                          //msgOnError: "Debe ingresar una dirección." // Optional.[Bool].Default: true. To determin if it is a required field.
                          customFunc: (res) => {
                            //Optional.[Func].Default: none. Custom function. Returns true or err message
                            res = datosPagador.direccion;
                            if (
                              res === "" ||
                              res === null ||
                              res === undefined
                            ) {
                              this.setState({ direccion: "" });
                              return "Por favor ingrese una dirección";
                            }
                            return true;
                          },
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Celular (*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Textbox
                        tabIndex="1"
                        type="text"
                        id="celular"
                        name="celular"
                        validate={validate}
                        classNameInput={"form-control"}
                        value={datosPagador.celular}
                        onChange={(celular, e) =>
                          this.setState((prevState) => ({
                            datosPagador: {
                              ...prevState.datosPagador,
                              celular,
                            },
                          }))
                        }
                        onBlur={(e) => {
                          //console.log(e);
                        }}
                        validationCallback={(res) =>
                          this.setState((prevState) => ({
                            valDatosPagador: {
                              ...prevState.valDatosPagador,
                              hasCelularError: res,
                            },
                            validate: false,
                          }))
                        }
                        validationOption={{
                          name: "celular", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          reg: /^\d{10}$/,
                          msgOnError:
                            "Por favor ingrese un número de celular valido",
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6} xs={12}>
                      <Checkbox
                        id={"mismosDatos"} // Optional.[String].Default: "".  Input ID.
                        name={"mismosDatos"} // Optional.[String].Default: "". Input name
                        value={mismosDatos} // Required.[String].Default: "".
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        checked={mismosDatos} // Required.[Bool].Default: false.
                        labelHtml={
                          <div style={{ paddingTop: "0.5em" }}>
                            <h5>
                              Utilizar los mismos datos para pago y facturación
                            </h5>
                          </div>
                        }
                        onChange={(mismosDatos, e) => {
                          this.setState({ mismosDatos });
                        }} // Required.[Func].Default: () => {}. Will return the value.
                        validationOption={{
                          name: "mismosDatos", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        }}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <div style={{ marginTop: '2rem' }}>
                    {/* Validacion de duplicidad */}
                    {console.log('test dup msg', this.props.datosListaNegra)}
                    {this.props.datosListaNegra.inListaNegra
                      ?
                      <Alert color="danger">
                        <center><p>{this.props.datosListaNegra.inListaNegraMensaje}</p></center>
                      </Alert>
                      :
                      null
                    }
                    {this.props.datosListaNegra.listaNegraError &&
                      <Alert color="danger">
                        <center><p>{ErrorMsgConstants.errorServicioListaNegra}</p></center>
                      </Alert>
                    }
                  </div>
            </Col>
            
            <Col
              lg={4}
              md={12}
              sm={12}
              xs={12}
              className="detalle-impuestos-box"
            >
              <ValoresCotizacion
                validarFormulario={this.validateForm}
                valoresTotales={this.props.dataFacturacion.carValoresTotales}
              />
            </Col>
          </Row>

          {!mismosDatos && (
            <Row>
              <Col
                lg={8}
                md={12}
                sm={12}
                xs={12}
                className="detalle-cotizacion-box"
              >
                <Card className="flex-row ">
                  <CardBody>
                    <Row>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <h4 style={{ fontWeight: "bold" }}>
                          Datos de Facturación
                        </h4>
                        <p />
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <div>(*) Campos Requeridos</div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Tipo de identificación(*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <Select1
                          tabIndex="6" // Optional.[String or Number].Default: none.
                          id={"selecTipoIdentificacionF"} // Optional.[String].Default: "". Input ID.
                          name={"selecTipoIdentificacionF"} // Optional.[String].Default: "". Input name.
                          value={datosFacturacion.codTipodocumento} // Optional.[String].Default: "".
                          validate={validate}
                          optionList={this.getTipoDocumentos()} // Required.[Array of Object(s)].Default: [].
                          onChange={(codTipodocumento, e) => {
                            this.setState((prevState) => ({
                              datosFacturacion: {
                                ...prevState.datosFacturacion,
                                codTipodocumento,
                              },
                            }));

                            if (codTipodocumento === infoIds.codigoPasaporteStr) {
                              this.setState((prevState) => ({
                                valDatosFacturacion: {
                                  ...prevState.valDatosFacturacion,
                                  esruc: false,
                                  esPasaporte: true,
                                  hasApellidoError: prevState.hasApellidoError,
                                  hasGeneroError: prevState.hasGeneroError,
                                  hasECivilError: prevState.hasECivilError,
                                  hasFechaIngresoPais: true,
                                  hasFechaEmisionPasaporte: true,
                                  hasFechaCaducidadPasaporte: true,
                                },
                              }));
                            } else if (codTipodocumento === infoIds.codigoRucStr) {
                              this.setState((prevState) => ({
                                valDatosFacturacion: {
                                  ...prevState.valDatosFacturacion,
                                  esruc: true,
                                  esPasaporte: false,
                                  hasApellidoError: false,
                                  hasGeneroError: false,
                                  hasECivilError: false,
                                  hasFechaIngresoPais: false,
                                  hasFechaEmisionPasaporte: false,
                                  hasFechaCaducidadPasaporte: false,
                                },
                              }));
                            } else {
                              this.setState((prevState) => ({
                                valDatosFacturacion: {
                                  ...prevState.valDatosFacturacion,
                                  esruc: false,
                                  esPasaporte: false,
                                  hasApellidoError: prevState.hasApellidoError,
                                  hasGeneroError: prevState.hasGeneroError,
                                  hasECivilError: prevState.hasECivilError,
                                  hasFechaIngresoPais: false,
                                  hasFechaEmisionPasaporte: false,
                                  hasFechaCaducidadPasaporte: false,
                                },
                              }));
                            }
                            document.getElementById("identificacionF").focus();
                            //document.getElementById("selecTipoIdentificacionF").focus();
                          }} // Optional.[Func].Default: () => {}. Will return the value.
                          onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                          validationCallback={(res) =>
                            this.setState((prevState) => ({
                              valDatosFacturacion: {
                                ...prevState.valDatosFacturacion,
                                hasCodTipoDocError: res,
                              },
                              validate: false,
                            }))
                          }
                          validationOption={{
                            name: "selecTipoIdentificacionF", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError:
                              "Por favor seleccione el tipo de identificación",
                          }}
                        />
                      </Col>
                    </Row>
                    {datosFacturacion && datosFacturacion.codTipodocumento && datosFacturacion.codTipodocumento === infoIds.codigoRucStr &&
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Seleccione personería(*)</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          <Select1
                            tabIndex="6" // Optional.[String or Number].Default: none.
                            id={"selectPersoneriaF"} // Optional.[String].Default: "". Input ID.
                            name={"selectPersoneriaF"} // Optional.[String].Default: "". Input name.
                            value={personeriValueF} // Optional.[String].Default: "".
                            validate={validate}
                            optionList={listadoTipoDocumentos} // Required.[Array of Object(s)].Default: [].
                            onChange={(personeria, e) => {
                              if (personeriValueF !== personeria) {
                                this.setState({
                                  personeriValueF: personeria,
                                });
                              }
                            }} // Optional.[Func].Default: () => {}. Will return the value.
                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                            validationCallback={(res) =>
                              this.setState({
                                validate: false,
                              })
                            }
                            validationOption={{
                              name: "selectPersoneriaF", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                              msgOnError: "Por favor seleccione la personería",
                            }}
                          />
                        </Col>
                      </Row>
                    }
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Número de Identificación (*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <Textbox
                          tabIndex="1"
                          type="text"
                          id="identificacionF"
                          name="identificacionF"
                          classNameInput={"form-control"}
                          value={datosFacturacion.identificacion}
                          validate={validate}
                          onChange={(identificacion, e) => {
                            this.setState((prevState) => ({
                              datosFacturacion: {
                                ...prevState.datosFacturacion,
                                identificacion,
                              },
                            }));
                            if (
                              valDatosFacturacion.esruc &&
                              identificacion.length === 13 &&
                              datosFacturacion.codTipodocumento === infoIds.codigoRucStr
                            ) {
                              this.consultaRucCedula({
                                identificacion: identificacion,
                                tipo: "ruc",
                                tipodato: "2",
                              });
                            } else if (
                              !valDatosFacturacion.esruc &&
                              identificacion.length === 10 &&
                              datosFacturacion.codTipodocumento === infoIds.codigoCedulaStr
                            ) {
                              this.consultaRucCedula({
                                identificacion: identificacion,
                                tipo: "cedula",
                                tipodato: "2",
                              });
                            }
                          }}
                          onBlur={(e) => { }}
                          validationCallback={(res) =>
                            this.setState((prevState) => ({
                              valDatosFacturacion: {
                                ...prevState.valDatosFacturacion,
                                hasIdentificacionError: res,
                              },
                              validate: false,
                            }))
                          }
                          validationOption={{
                            name: "identificacionF", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            reg: valDatosFacturacion.esruc
                              ? /^\d{13}$/
                              : valDatosFacturacion.esPasaporte
                                ? ""
                                : /^\d{10}$/,
                            msgOnError:
                              "Por favor ingrese una identificación correcta",
                          }}
                        />
                      </Col>
                    </Row>
                    {valDatosFacturacion.esPasaporte === true && (
                      <div>
                        <Row>
                          <Col lg={4} md={4} sm={4} xs={12}>
                            <h5>Fecha Expedición Pasaporte (*)</h5>
                          </Col>
                          <Col lg={8} md={8} sm={8} xs={12}>
                            <DatePicker
                              {...this.props}
                              dateFormat="dd/MM/yyyy"
                              selected={datosFacturacion.fechaEmisionPasaporte}
                              onChange={(date) =>
                                this.setState((prevState) => ({
                                  datosFacturacion: {
                                    ...prevState.datosFacturacion,
                                    fechaEmisionPasaporte: date,
                                  },
                                  valDatosFacturacion: {
                                    ...prevState.valDatosFacturacion,
                                    hasFechaEmisionPasaporte: date
                                      ? false
                                      : true,
                                  },
                                }))
                              }
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="form-control"
                              placeholderText="Seleccione una fecha"
                              ref={(node) => {
                                this.ref = node;
                              }}
                            />
                            {valDatosFacturacion.hasFechaEmisionPasaporte && (
                              <span
                                style={{
                                  display: "block",
                                  color: "#ff5a57",
                                  fontSize: "1rem",
                                  marginLeft: "5px",
                                }}
                              >
                                Por favor ingrese una fecha
                              </span>
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={4} sm={4} xs={12}>
                            <h5>Fecha Vencimiento Pasaporte (*)</h5>
                          </Col>
                          <Col lg={8} md={8} sm={8} xs={12}>
                            <DatePicker
                              {...this.props}
                              dateFormat="dd/MM/yyyy"
                              selected={
                                datosFacturacion.fechaCaducidadPasaporte
                              }
                              onChange={(date) =>
                                this.setState((prevState) => ({
                                  datosFacturacion: {
                                    ...prevState.datosFacturacion,
                                    fechaCaducidadPasaporte: date,
                                  },
                                  valDatosFacturacion: {
                                    ...prevState.valDatosFacturacion,
                                    hasFechaCaducidadPasaporte: date
                                      ? false
                                      : true,
                                  },
                                }))
                              }
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="form-control"
                              placeholderText="Seleccione una fecha"
                              ref={(node) => {
                                this.ref = node;
                              }}
                            />
                            {valDatosFacturacion.hasFechaCaducidadPasaporte && (
                              <span
                                style={{
                                  display: "block",
                                  color: "#ff5a57",
                                  fontSize: "1rem",
                                  marginLeft: "5px",
                                }}
                              >
                                Por favor ingrese una fecha
                              </span>
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={4} sm={4} xs={12}>
                            <h5>Fecha Ingreso al País (*)</h5>
                          </Col>
                          <Col lg={8} md={8} sm={8} xs={12}>
                            <DatePicker
                              {...this.props}
                              dateFormat="dd/MM/yyyy"
                              selected={datosFacturacion.fechaIngresoPais}
                              onChange={(date) =>
                                this.setState((prevState) => ({
                                  datosFacturacion: {
                                    ...prevState.datosFacturacion,
                                    fechaIngresoPais: date,
                                  },
                                  valDatosFacturacion: {
                                    ...prevState.valDatosFacturacion,
                                    hasFechaIngresoPais: date ? false : true,
                                  },
                                }))
                              }
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="form-control"
                              placeholderText="Seleccione una fecha"
                              ref={(node) => {
                                this.ref = node;
                              }}
                            />
                            {valDatosFacturacion.hasFechaIngresoPais && (
                              <span
                                style={{
                                  display: "block",
                                  color: "#ff5a57",
                                  fontSize: "1rem",
                                  marginLeft: "5px",
                                }}
                              >
                                Por favor ingrese una fecha
                              </span>
                            )}
                          </Col>
                        </Row>
                      </div>
                    )}
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>
                          {!valDatosFacturacion.esruc
                            ? "Nombres (*)"
                            : "Razón Social (*)"}
                        </h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <Textbox
                          tabIndex="1"
                          type="text"
                          id="cliNombres"
                          name="cliNombres"
                          validate={validate}
                          classNameInput={"form-control"}
                          value={datosFacturacion.cliNombres}
                          onChange={(cliNombres, e) =>
                            this.setState((prevState) => ({
                              datosFacturacion: {
                                ...prevState.datosFacturacion,
                                cliNombres: cliNombres.toUpperCase().trimStart(),
                              },
                            }))
                          }
                          onBlur={(e) => { }}
                          validationCallback={(res) =>
                            this.setState((prevState) => ({
                              valDatosFacturacion: {
                                ...prevState.valDatosFacturacion,
                                hasNombreError: res,
                              },
                              validate: false,
                            }))
                          }
                          validationOption={{
                            name: "nombre", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            reg: valDatosFacturacion.esruc
                              ? ""
                              : /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/,
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError:
                              "Por favor ingrese los nombres, No deben tener caracteres especiales",
                          }}
                        />
                      </Col>
                    </Row>
                    {!valDatosFacturacion.esruc && (
                      <div>
                        <Row>
                          <Col lg={4} md={4} sm={4} xs={12}>
                            <h5>Apellidos (*)</h5>
                          </Col>
                          <Col lg={8} md={8} sm={8} xs={12}>
                            <Textbox
                              tabIndex="1"
                              type="text"
                              id="apellido"
                              name="apellido"
                              validate={validate}
                              classNameInput={"form-control"}
                              value={datosFacturacion.cliApellidos}
                              onChange={(cliApellidos, e) =>
                                this.setState((prevState) => ({
                                  datosFacturacion: {
                                    ...prevState.datosFacturacion,
                                    cliApellidos: cliApellidos.toUpperCase().trimStart(),
                                  },
                                }))
                              }
                              onBlur={(e) => {
                                //console.log(e);
                              }}
                              validationCallback={(res) =>
                                this.setState((prevState) => ({
                                  valDatosFacturacion: {
                                    ...prevState.valDatosFacturacion,
                                    hasApellidoError: res,
                                  },
                                  validate: false,
                                }))
                              }
                              validationOption={{
                                //name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                //check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                reg: /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/,
                                msgOnError:
                                  "Por favor ingrese los apellidos correctamente",
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={4} sm={4} xs={12}>
                            <h5>Estado Civil(*)</h5>
                          </Col>
                          <Col lg={8} md={8} sm={8} xs={12}>
                            <Select1
                              tabIndex="6" // Optional.[String or Number].Default: none.
                              id={"estadosCiviles"} // Optional.[String].Default: "". Input ID.
                              name={"estadosCiviles"} // Optional.[String].Default: "". Input name.
                              value={datosFacturacion.codEstadoCivil} // Optional.[String].Default: "".
                              optionList={catalogos.estadosCiviles} // Required.[Array of Object(s)].Default: [].
                              validate={validate}
                              onChange={(codEstadoCivil, e) =>
                                this.setState((prevState) => ({
                                  datosFacturacion: {
                                    ...prevState.datosFacturacion,
                                    codEstadoCivil,
                                  },
                                }))
                              }
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                              validationCallback={(res) =>
                                this.setState((prevState) => ({
                                  valDatosFacturacion: {
                                    ...prevState.valDatosFacturacion,
                                    hasECivilError: res,
                                  },
                                  validate: false,
                                }))
                              }
                              validationOption={{
                                name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError:
                                  "Por favor seleccione su estado civil",
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={4} sm={4} xs={12}>
                            <h5>Género(*)</h5>
                          </Col>
                          <Col lg={8} md={8} sm={8} xs={12}>
                            <Select1
                              tabIndex="6" // Optional.[String or Number].Default: none.
                              id={"generos"} // Optional.[String].Default: "". Input ID.
                              name={"generos"} // Optional.[String].Default: "". Input name.
                              value={datosFacturacion.codGenero} // Optional.[String].Default: "".
                              optionList={catalogos.generos} // Required.[Array of Object(s)].Default: [].
                              validate={validate}
                              onChange={(codGenero, e) =>
                                this.setState((prevState) => ({
                                  datosFacturacion: {
                                    ...prevState.datosFacturacion,
                                    codGenero,
                                  },
                                }))
                              }
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                              validationCallback={(res) =>
                                this.setState((prevState) => ({
                                  valDatosFacturacion: {
                                    ...prevState.valDatosFacturacion,
                                    hasGeneroError: res,
                                  },
                                  validate: false,
                                }))
                              }
                              validationOption={{
                                name: "generos", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione el género",
                              }}
                            />
                          </Col>
                        </Row>
                      </div>
                    )}
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Provincia(*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <Select
                          value={datosFacturacion.provincia}
                          components={makeAnimated()}
                          onChange={(provincia, e) => {
                            this.setState((prevState) => ({
                              datosFacturacion: {
                                ...prevState.datosFacturacion,
                                provincia,
                                ciudad: "",
                              },
                              valDatosFacturacion: {
                                ...prevState.valDatosFacturacion,
                                hasProvinciaError: provincia ? false : true,
                              },
                            }));
                            this.props.onChangeProvincia(
                              provincia.value.toString()
                            );
                          }}
                          options={catalogos.provinciasSelect}
                          isSearchable={true}
                          placeholder={"Seleccione una provincia"}
                          isMulti={false}
                        />
                        {valDatosFacturacion.hasProvinciaError && (
                          <span
                            style={{
                              color: "#ff5a57",
                              fontSize: "1rem",
                              marginLeft: "5px",
                            }}
                          >
                            Por favor seleccione una provincia
                          </span>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Ciudad(*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <Select
                          value={datosFacturacion.ciudad}
                          components={makeAnimated()}
                          onChange={(ciudad, e) => {
                            this.setState((prevState) => ({
                              datosFacturacion: {
                                ...prevState.datosFacturacion,
                                ciudad,
                              },
                              valDatosFacturacion: {
                                ...prevState.valDatosFacturacion,
                                hasCiudadError: ciudad ? false : true,
                              },
                            }));
                          }}
                          options={catalogos.ciudadesSelect}
                          isSearchable={true}
                          placeholder={"Seleccione una ciudad"}
                          isMulti={false}
                        />
                        {valDatosFacturacion.hasCiudadError && (
                          <span
                            style={{
                              color: "#ff5a57",
                              fontSize: "1rem",
                              marginLeft: "5px",
                            }}
                          >
                            Por favor seleccione una ciudad
                          </span>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>
                          {!valDatosFacturacion.esruc
                            ? "Fecha nacimiento(*)"
                            : "Fecha de Constitución (*)"}
                        </h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <DatePicker
                          {...this.props}
                          dateFormat="dd/MM/yyyy"
                          selected={
                            typeof datosFacturacion.fechaNacimiento === "string" ? this.cambiarStringaFecha(datosFacturacion.fechaNacimiento) : datosFacturacion.fechaNacimiento
                          }
                          onChange={(date) =>
                            this.setState((prevState) => ({
                              datosFacturacion: {
                                ...prevState.datosFacturacion,
                                fechaNacimiento: date,
                              },
                              valDatosFacturacion: {
                                ...prevState.valDatosFacturacion,
                                hasFechaNacimiento: date ? false : true,
                              },
                            }))
                          }
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="form-control"
                          placeholderText="Seleccione una fecha"
                          ref={(node) => {
                            this.ref = node;
                          }}
                        />

                        {valDatosFacturacion.hasFechaNacimiento && (
                          <span
                            style={{
                              display: "block",
                              color: "#ff5a57",
                              fontSize: "1rem",
                              marginLeft: "5px",
                            }}
                          >
                            Por favor ingrese una fecha
                          </span>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Correo Electrónico (*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <Textbox
                          type="text"
                          id="correo"
                          name="correo"
                          validate={validate}
                          classNameInput={"form-control"}
                          value={`${datosFacturacion.correo}`}
                          onChange={(correo, e) =>
                            this.setState((prevState) => ({
                              datosFacturacion: {
                                ...prevState.datosFacturacion,
                                correo,
                              },
                            }))
                          }
                          onBlur={(e) => {
                            //console.log(e);
                          }}
                          validationCallback={(res) =>
                            this.setState((prevState) => ({
                              valDatosFacturacion: {
                                ...prevState.valDatosFacturacion,
                                hasCorreoError: res,
                              },
                              validate: false,
                            }))
                          }
                          validationOption={{
                            name: "correo", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            reg: expresionesRegulares.email,
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError:
                              "Por favor ingrese un correo electronico válido", // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Dirección (*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <Textarea
                          // tabIndex="1"
                          type="input"
                          value={datosFacturacion.direccion}
                          name="direccion"
                          id="direccion"
                          classNameInput={"form-control"}
                          validate={validate}
                          onChange={(direccion, e) =>
                            this.setState((prevState) => ({
                              datosFacturacion: {
                                ...prevState.datosFacturacion,
                                direccion: direccion.toUpperCase().trimStart(),
                              },
                            }))
                          }
                          onBlur={(e) => {
                            //console.log(e);
                          }}
                          validationCallback={(res) =>
                            this.setState((prevState) => ({
                              valDatosFacturacion: {
                                ...prevState.valDatosFacturacion,
                                hasDireccionError: res,
                              },
                              validate: false,
                            }))
                          }
                          validationOption={{
                            name: "direccion", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                            //msgOnError: "Debe ingresar una dirección." // Optional.[Bool].Default: true. To determin if it is a required field.
                            customFunc: (res) => {
                              //Optional.[Func].Default: none. Custom function. Returns true or err message
                              res = datosFacturacion.direccion;
                              if (
                                res === "" ||
                                res === null ||
                                res === undefined
                              ) {
                                this.setState({ direccion: "" });
                                return "Por favor ingrese una dirección";
                              }
                              return true;
                            },
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Celular (*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <Textbox
                          tabIndex="1"
                          type="text"
                          id="celular"
                          name="celular"
                          validate={validate}
                          classNameInput={"form-control"}
                          value={datosFacturacion.celular}
                          onChange={(celular, e) =>
                            this.setState((prevState) => ({
                              datosFacturacion: {
                                ...prevState.datosFacturacion,
                                celular,
                              },
                            }))
                          }
                          onBlur={(e) => {
                            //console.log(e);
                          }}
                          validationCallback={(res) =>
                            this.setState((prevState) => ({
                              valDatosFacturacion: {
                                ...prevState.valDatosFacturacion,
                                hasCelularError: res,
                              },
                              validate: false,
                            }))
                          }
                          validationOption={{
                            name: "celular", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            reg: /^\d{10}$/,
                            msgOnError:
                              "Por favor ingrese un número de celular valido",
                          }}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Page>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = (state) => ({
  //userIsLoggedIn: state.datosUsuarios.dataUsuario.userIsLoggedIn,
  catalogos: state.catalogosCotizacion,
  dataUsuario: state.datosUsuarios.dataUsuario,
  datosIdentificacion: state.datosIdentificacionAP,
  respuestaFacturacion: state.dataGuardarFacturacion,
  datosListaNegra: state.datosListaNegra,
});

const mapDispatchToProps = (dispatch) => {
  return {
    consultarIdentificacion: (datos) =>
      dispatch(fetchConsultarIdentificacionAP(datos)),
    guardarFacturacion: (data) => dispatch(guardarFacturacionFetch(data)),
    checkInListaNegra: (identificacion) => dispatch(estaEnListaNegra(identificacion)),
    limpiarDatosListaNegra: () => dispatch(LimpiarListaNegra()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(datosFacturacion)
);
